import { render, staticRenderFns } from "./type110.vue?vue&type=template&id=85603c08&scoped=true"
import script from "./type110.vue?vue&type=script&lang=js"
export * from "./type110.vue?vue&type=script&lang=js"
import style0 from "./type110.vue?vue&type=style&index=0&id=85603c08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85603c08",
  null
  
)

export default component.exports